import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query eeocByCandidate($candidate: MongoID!) {
    cat {
      eeoc {
        findEeocByCandidate(candidate: $candidate) {
          _id
          status
          createdAt
          signedOn 
          documents
          voidedOn
          voidReason
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type EeocByCandidate = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['eeoc']>['findEeocByCandidate']>

const useEeocByCandidate = (candidate: string): EeocByCandidate | null | undefined => {
  const { data } = useGraphQL(document, { candidate }, {
    enabled: typeof candidate === 'string'
  })
  return data?.cat?.eeoc?.findEeocByCandidate
}

export { useEeocByCandidate, document as eeocByCandidateDocument }
